var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pb-0",attrs:{"fluid":""}},[_c('div',[[_c('v-row',{staticClass:"h-100"},[_c('v-col',{staticClass:"pt-1 pb-0",attrs:{"cols":"12"}},[_c('SearchPatient')],1)],1)]],2)])}
var staticRenderFns = []

export { render, staticRenderFns }